export const zhaparova = {
  id: 'zhaparova',
  name: {
    ru: 'Жапарова Айжан Мухтаровна',
    kz: 'Жапарова Айжан Мұхтарқызы',
  },
  position: {
    ru: 'Врач-кардиолог',
    kz: 'Дәрігер-кардиолог',
  },
  department: 'specialists',
  image: '/team_photoes/new/aizhan.png',
  experience: {
    ru: 'Более 20 лет',
    kz: '20 жылдан астам',
  },
  education: {
    ru: `• 1995–2003 — Медицинская академия, г. Астана`,
    kz: `• 1995–2003 — Астана қаласының Медицина академиясы`,
  },
  work: {
    ru: `• 2003–2006 — Енбекшильдерская районная больница, фтизиатр, Акмолинская обл.
• 2006–2010 — ГССМП, выездная специализированная бригада, г. Астана
• 2010–2012 — Кардиологические отделения, г. Астана
• 2012 — Институт кардиологии и внутренних болезней, г. Алматы
• 2013 — Республиканский семейно-врачебный центр, г. Алматы
• 2013–2019 — Городская поликлиника №1, г. Алматы
• 2020–2023 — ЦСО «Шарапат» 
• 2021–2024 — Многопрофильный медицинский центр, инсультное отделение, г. Астана
• 2024 – по настоящее время — ГКП на ПХВ «Городская поликлиника №2», г. Астана
• 2024 – по настоящее время — Поликлиника Департамента полиции, г. Астана`,
    kz: `• 2003–2006 — Еңбекшілдер аудандық ауруханасы, фтизиатр, Ақмола облысы
• 2006–2010 — Астана қаласының ГССМП, жүргізуші мамандандырылған бригадасы
• 2010–2012 — Астана қаласының Кардиология бөлімдері
• 2012 — Алматы қаласының Кардиология және ішкі аурулар институты
• 2013 — Алматы қаласының Республикалық отбасылық дәрігерлік орталығы
• 2013–2019 — Алматы қаласының 1-ші қалалық емханасы
• 2020–2023 — «Шарапат» ЦСО
• 2021–2024 — Астана қаласының Көпсалалы медициналық орталығы, инсульт бөлімі
• 2024 – қазіргі уақытқа дейін — Астана қаласының «2-ші қалалық емханасы» ГКП на ПХВ
• 2024 – қазіргі уақытқа дейін — Астана қаласының Полиция департаментінің емханасы`,
  },
  certificates: {
    ru: '',
    kz: '',
  },
}; 
